<script>
    import HighlightsOverviewPage from "./HighlightsOverviewPage.svelte";
</script>

<HighlightsOverviewPage isExplore={true} />
